import * as React from "react";
import Button from "@mui/material/Button";
import { Autocomplete, TextField } from "@mui/material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import {
  Appointment,
  SelectedappointmentControlsOption,
} from "../interface/bookingOverviewInterface";
import { BookingOverviewContext } from "../context/bookingOverviewContext";

const AppointmentControlls = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => {
  const {
    appointmentControlsOptions,
    doCancellation,
  }: {
    appointmentControlsOptions: SelectedappointmentControlsOption[];
    doCancellation: (
      appointment: Appointment,
      selectedOption: SelectedappointmentControlsOption | null,
      setSelectedOption: React.Dispatch<
        React.SetStateAction<SelectedappointmentControlsOption | null>
      >
    ) => void;
  } = React.useContext(BookingOverviewContext);

  const [selectedOption, setSelectedOption] =
    React.useState<SelectedappointmentControlsOption | null>(null);

  return (
    <React.Fragment>
      <Autocomplete
        size="small"
        disablePortal
        isOptionEqualToValue={(option, value) => option.value === value.value}
        id="combo-box-demo"
        fullWidth
        options={appointmentControlsOptions}
        value={selectedOption}
        onChange={(
          _event: any,
          newValue: SelectedappointmentControlsOption | null
        ) => {
          setSelectedOption(newValue);
        }}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} label="Aktion" />}
      />
      <Button
        disabled={selectedOption === null}
        onClick={() =>
          doCancellation(appointment, selectedOption, setSelectedOption)
        }
        variant="contained"
        color="primary"
      >
        <CheckBoxOutlinedIcon />
      </Button>
    </React.Fragment>
  );
};

export default AppointmentControlls;
